import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['saleOrder'],
  saleOrder: (payload: { id: string }): QueryKey => [...queryKeys.all, payload.id],
};
